import { typography } from '../global/typography';
import { palette } from '../global/palette';
import { shape } from '../global/shape';
export const MuiBadge = {
    MuiBadge: {
        styleOverrides: {
            badge: {
                paddingLeft: 5,
                paddingRight: 5,
                paddingTop: 1,
                paddingBottom: 1,
                fontSize: typography.pxToRem(10),
                fontWeight: typography.fontWeightBold,
                borderRadius: shape.borderRadius,
                height: 16,
                minWidth: 15,
            },
            colorError: {
                color: palette.common.white,
            },
        },
        defaultProps: {
            color: 'error',
            overlap: 'circular',
        },
    },
};
